
export const LOGIN_DATA = "login_data";